import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import {
  BulkCreateSpeakersPayload,
  BulkCreateSpeakersResult
} from '@utils/types/organization/speaker.ts';

// Backend accepts ?dry_run=true to validate + dedup-check without persisting.
// The bulk-upload review step uses it to warn about conflicts before commit.
export interface BulkCreateSpeakersArgs extends BulkCreateSpeakersPayload {
  dryRun?: boolean;
}

const postBulkSpeakers = async ({
  dryRun,
  ...payload
}: BulkCreateSpeakersArgs): Promise<BulkCreateSpeakersResult> => {
  const url = dryRun
    ? `${POST_URL().bulkCreateSpeakers}?dry_run=true`
    : POST_URL().bulkCreateSpeakers;
  const { data } = await Axios.post<BulkCreateSpeakersResult>(url, payload);
  return data;
};

export const useBulkCreateSpeakers = () => {
  const queryClient = useQueryClient();

  return useMutation<
    BulkCreateSpeakersResult,
    AxiosError<BaseError>,
    BulkCreateSpeakersArgs
  >(postBulkSpeakers, {
    onSuccess: (_data, variables) => {
      if (!variables.dryRun) {
        queryClient.invalidateQueries(['speakers']);
      }
    },
    useErrorBoundary: false
  });
};
